import { Controller } from "@hotwired/stimulus"
import Rails from "@rails/ujs";

export default class extends Controller {
  static targets = [ "container", "label", "chevron" ]

  initialize() {
    this.timeout = null;
    if (this.element.dataset.value == "closed") {
      this.collapse();
    }
  }

  toggle() {
    if (this.containerTarget.classList.contains("w-[5.5em]")) {
      this.expand();
      this.storeCache("opened")
    } else {
      this.collapse();
      this.storeCache("closed")
    }
  }

  collapse() {
    this.labelTargets.forEach(label => {
      label.classList.replace("opacity-100", "opacity-0");
      label.classList.add("w-0")
    })
    this.chevronTargets.forEach(chevron => {
      chevron.classList.replace("opacity-100", "opacity-0");
      chevron.classList.add("scale-0")
    })
    this.containerTarget.classList.replace("w-64", "w-[5.5em]")
  }

  expand() {
    this.containerTarget.classList.replace("w-[5.5em]", "w-64")

    setTimeout(() => {
      this.labelTargets.forEach(label => {
        label.classList.replace("opacity-0", "opacity-100");
        label.classList.remove("w-0")
      })
      this.chevronTargets.forEach(chevron => {
        chevron.classList.replace("opacity-0", "opacity-100");
        chevron.classList.remove("scale-0")
      })
    }, 150)
  }

  checkClick(event) {
    if (this.containerTarget.classList.contains("w-[5.5em]")) {
      event.preventDefault();
      event.stopImmediatePropagation();

      const currentDropdown = event.currentTarget.closest('[data-controller="dropdown"]');
      const firstLink = currentDropdown ? currentDropdown.querySelector("a") : null;

      if (firstLink) {
        firstLink.click();
      }
    }
  }


  storeCache(value) {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      Rails.ajax({
        type: 'GET',
        url: `/users/store_menu?value=${value}`,
        success: () => {},
        error: () => {
          alert('Произошла ошибка!');
        },
      });
    }, 500);
  }
}